module.exports = __webpack_public_path__ + "static/media/heat_3.d858e571.png";